import UserQuery from '@/api/account/user/query.js';

export const user = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: {
    users: []
  },
  getters: {
    users: state => state.users
  },
  mutations: {
    setUsers(state, users) {
      state.users = users;
    },
    clear(state) {
      state.users = [];
    }
  },
  actions: {
    setUsers({ commit, state }) {
      if (!state.users.length) {
        UserQuery.getCompanyUserList().then(res => {
          commit('setUsers', res.data.data);
        });
      }
    },
    clearUsers({ commit }) {
      commit('clear');
    }
  }
};
